import { convertWhitespaceToPlusInSlug } from "./convertWhitespaceToPlusInSlug";

export const getSlugForProfileUserPage = (str: string) => {
  const slug = str.slice(1).trim();
  const isValidSlug = slug.length > 0;
  const isCorrectFormat = str[0] === "@";
  const isValid = isValidSlug && isCorrectFormat;
  if (isValid) return convertWhitespaceToPlusInSlug(slug);
  return null;
};
